import Select from 'react-select';
import { BERG_STORE } from '@constants';
// eslint-disable-next-line no-unused-vars
import { store as blockStore } from '@store'; // NOSONAR

const {
  i18n: { __ },
  components: { PanelBody },
  data: { select },
} = wp;

const FlexSettings = ({ flexSettings, setAttributes, name }) => {
  const flexSettingsClassOptions = select(BERG_STORE).getBlockAttributeOptions(
    name,
    'flexSettings',
  );

  const displayFlexSettings = () => {
    const flexSettingsElm = [];

    for (const [key, value] of Object.entries(flexSettings)) {
      const label = `${key} Flex Settings`;
      flexSettingsElm.push(
        <div className="cfs-felid" key={key}>
          <div className="cfs-felid-label">
            {key.toUpperCase()} Settings {key === 'xs' && '(Default)'}
          </div>
          <Select
            label={label}
            defaultValue={value}
            placeholder={label}
            isMulti
            name={`${key}FlexClassNames`}
            options={flexSettingsClassOptions[key]}
            onChange={(selectedFlexSettings) => {
              setAttributes({
                flexSettings: {
                  ...flexSettings,
                  [key]: selectedFlexSettings,
                },
              });
            }}
          />
        </div>,
      );
    }

    return flexSettingsElm;
  };

  return (
    <PanelBody title={__('Flex Settings', 'b3rg')} initialOpen={false}>
      {displayFlexSettings()}
    </PanelBody>
  );
};

export default FlexSettings;
